import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { useMainLayout } from 'src/layouts/MainLayoutProvider';

const AppBreadcrumb = () => {
  const { breadcrumb } = useMainLayout();

  return (
    <Breadcrumb>
      {breadcrumb.map((item, index) => {
        return (
          <Breadcrumb.Item key={item.to}>
            <Link to={item.to}>{item.name}</Link>
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default AppBreadcrumb; 